import React from 'react';

const TextBox = ({ label, placeholder, value, onChange, customStyles, isStatusDisplayed, error, ...props }) => {
  const textBoxClassName = `custom-textbox ${isStatusDisplayed ? (error ? "custom-textbox-danger" : "custom-textbox-success") : "" }`;

  const handleChange = (e) => {
    onChange && onChange(e);
  };

  return (
    <div className={textBoxClassName} style={{ ...customStyles }}>
      {label && <p className='label'>{label}</p>}
      <input type="text" value={value} placeholder={placeholder} onChange={handleChange} {...props}/>
      {isStatusDisplayed && error && <p className='error'>{error}</p>}
    </div>
  );
};

export default TextBox;